import { ReactNode } from 'react';
import { Divider } from 'antd';
import Details, { DetailsProps } from './Details';
import Metadata from './Metadata';
import MoreInformation from './MoreInformation';

type Props = {
    messageMetadata: Record<string, ReactNode>;
    details?: DetailsProps;
    children?: ReactNode;
};

const MessageDetails = ({ messageMetadata, details, children }: Props) => (
    <>
        <Metadata metadata={messageMetadata} />
        <Divider />
        {details ? <Details {...details} /> : children}
        <Divider />
        <MoreInformation />
    </>
);

export default MessageDetails;
